import { formatInTimeZone } from "date-fns-tz";
import { es } from "date-fns/locale";

export const formatScheduleEventRange = (startDate, endDate) => {
  const timeZone = "America/Bogota";
  const monthDay = formatInTimeZone(startDate, timeZone, "MMMM d", {
    locale: es,
  });
  const startHour = formatInTimeZone(startDate, timeZone, "h:mm aaaa", {
    locale: es,
  });
  const endHour = formatInTimeZone(endDate, timeZone, "h:mm aaaa", {
    locale: es,
  });

  return `${monthDay} - ${startHour} a ${endHour}`;
};

export const formatScheduleEventDateTime = (startDate) => {
  const timeZone = "America/Bogota";
  const dayName = formatInTimeZone(startDate, timeZone, "EEEE", {
    locale: es,
  });
  const day = formatInTimeZone(startDate, timeZone, "d", {
    locale: es,
  });
  const month = formatInTimeZone(startDate, timeZone, "MMMM", {
    locale: es,
  });
  const time = formatInTimeZone(startDate, timeZone, "h:mm aaaa", {
    locale: es,
  });

  const capitalizedDayName =
    dayName.charAt(0).toUpperCase() + dayName.slice(1).toLowerCase();
  return `${capitalizedDayName}, ${day} de ${month} a las ${time}`;
};
